import { useMemo } from 'react';
import _ from 'lodash';

export default function useChartOptions(baseOptions, overrides = {}, deps = []) {
    return useMemo(() => {
        const cloned = _.cloneDeep(baseOptions);
        return _.merge(cloned, overrides);
    }, [baseOptions, JSON.stringify(overrides), ...deps]);
}
